import * as React from 'react';
import { cn } from '@/lib/utils';

const EssayCardTimelineWrapper = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-essay-card-timeline-wrapper',
      // styles
      'relative flex flex-col gap-3',
      "before:absolute before:bottom-0 before:left-[22px] before:top-0 before:z-0 before:mb-10 before:mt-2 before:w-0 before:border-l before:border-dashed before:border-neutral-light before:content-['']",
      className
    )}
    {...props}
  />
));
EssayCardTimelineWrapper.displayName = 'EssayCardTimelineWrapper';

const EssayCardTimeline = React.forwardRef(({ className, isActive, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-essay-card-timeline',
      // styles
      'relative flex w-full cursor-pointer items-center gap-3 rounded-[10px] p-2 text-xs transition-colors',
      isActive ? 'bg-primary-lightest text-primary' : 'text-neutral-light',
      className
    )}
    {...props}
  />
));
EssayCardTimeline.displayName = 'EssayCardTimeline';

const EssayCardTimelinePosition = React.forwardRef(({ className, isActive, ...props }, ref) => (
  <span
    ref={ref}
    className={cn(
      'c-essay-card-timeline-position',
      // styles
      'flex h-[30px] w-[30px] shrink-0 items-center justify-center self-start rounded-full text-white transition-colors',
      isActive ? 'bg-primary' : 'bg-neutral-light',
      className
    )}
    {...props}
  />
));
EssayCardTimelinePosition.displayName = 'EssayCardTimelinePosition';

const EssayCardTimelineDescription = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-essay-card-timeline-description',
      // styles
      'flex flex-col gap-1',
      className
    )}
    {...props}
  />
));
EssayCardTimelineDescription.displayName = 'EssayCardTimelineDescription';

const EssayCardTimelineScore = React.forwardRef(({ className, variant, ...props }, ref) => {
  const variantClasses = {
    success: 'text-success',
    warning: 'text-warning',
    danger: 'text-danger'
  };

  return (
    <div
      ref={ref}
      className={cn(
        'c-essay-card-timeline-score',
        // styles
        'ml-auto rounded-[10px] bg-white p-2 text-center shadow-dropshadow',
        variantClasses[variant] || 'text-neutral-light',
        className
      )}
      {...props}
    />
  );
});
EssayCardTimelineScore.displayName = 'EssayCardTimelineScore';

const EssayCardTimelineScoreValue = React.forwardRef(({ className, ...props }, ref) => (
  <strong
    ref={ref}
    className={cn(
      'c-essay-card-timeline-score-value',
      // styles
      'block text-[20px] font-bold leading-[20px]',
      className
    )}
    {...props}
  />
));
EssayCardTimelineScoreValue.displayName = 'EssayCardTimelineScoreValue';

export { EssayCardTimelineWrapper, EssayCardTimeline, EssayCardTimelinePosition, EssayCardTimelineDescription, EssayCardTimelineScore, EssayCardTimelineScoreValue };
